import { useState, useRef } from "react";
import "./Contact.css";
import { slideIn } from "../utils/motion";
import { motion } from "framer-motion";
import { styles } from "../styles";
import { EarthCanvas } from "./canvas";
import { SectionWrapper } from "../hoc";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";
import { socials } from "../constants";

const Contact = () => {
  const formRef = useRef();
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .send(
        "service_27uux39",
        "template_0r13lgw",
        {
          from_name: form.name,
          to_name: "Jacek Chmiel",
          from_email: form.email,
          to_email: "jacekchmiel03@gmail.com",
          message: form.message,
        },
        "FHDUvsc4HkNgzksV2"
      )
      .then(
        () => {
          setLoading(false);
          alert("Thank you. I will get back to you as soon as possible.");

          setForm({
            name: "",
            email: "",
            message: "",
          });
        },
        (error) => {
          setLoading(false);
          console.error(error);

          alert("Whoooops, something went wrong. Please try again.");
        }
      );
  };

  return (
    <>
      <motion.div
        variants={slideIn("down", "tween", 0.2, 1)}
        className="sm:mt-20 md:mt-32 mb-16 pl-8 pr-8 pb-8 pt-4 max-w-lg glass ml-auto mr-auto"
      >
        <p className={`${styles.sectionSubText} text-center mb-4`}>Social media</p>
        <ul className="flex flex-row justify-center align-middle flex-grow">
          {socials.map((item, index) => (
            <li key={index} className="cursor-pointer flex-grow">
              <Link to={item.path} className="flex flex-col items-center text-white">
                <div className="border-container">
                  <div
                    className="border-layer layer1"
                    style={{ border: `1px solid ${item.color}` }}
                  ></div>
                  <div
                    className="border-layer layer2"
                    style={{ border: `1px solid ${item.color}` }}
                  ></div>
                  <div
                    className="border-layer layer3"
                    style={{ border: `1px solid ${item.color}` }}
                  ></div>
                  <div
                    className="border-layer layer4"
                    style={{ border: `1px solid ${item.color}` }}
                  ></div>
                  <div className="icon-container">
                    <span className="text-5xl">{item.icon}</span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </motion.div>
      <div className="md:flex-row flex-col-reverse flex-grow gap-10 overflow-hidden flex justify-center">
        <motion.div
          className="flex-grow min-w-[350px] w-full flex-[0.75] bg-black-100 p-8 self-start"
          variants={slideIn("left", "tween", 0.2, 1)}
        >
          <p className={styles.sectionSubText}>Get in touch</p>
          <h3 className={styles.sectionHeadText}>Contact.</h3>

          <form ref={formRef} onSubmit={handleSubmit} className="mt-12 flex flex-col gap-8">
            <label className="flex flex-col">
              <span className="text-white font-medium mb-4">Your Name</span>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="What's your name?"
                className="bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outlined-none focus:outline-none focus:ring-2 border-none font-medium"
              ></input>
            </label>

            <label className="flex flex-col">
              <span className="text-white font-medium mb-4">Your Email</span>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="What's your email?"
                className="bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outlined-none focus:outline-none focus:ring-2 border-none font-medium"
              ></input>
            </label>

            <label className="flex flex-col">
              <span className="text-white font-medium mb-4">Your Message</span>
              <textarea
                rows="7"
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="What do you want to say?"
                className="bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outlined-none focus:outline-none focus:ring-2 border-none font-medium"
              ></textarea>
            </label>

            <button
              type="submit"
              className="bg-tertiary py-3 px-8 outline-none w-fit text-white font-bold shadow-md shadow-primary rounded-xl"
            >
              {loading ? "Sending..." : "Send"}
            </button>
          </form>
        </motion.div>

        <motion.div className="xl:flex-1 md:h-[550]" variants={slideIn("right", "tween", 0.2, 1)}>
          <EarthCanvas />
        </motion.div>
      </div>
    </>
  );
};

export default SectionWrapper(Contact);
